
export const crosshairsSynchronizers = {
    synchronizers: {}
};
